// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__PrqY-","appearModal":"Modal_appearModal__UcFWt"};